<div class="main-container">
    <mat-toolbar class="mat-elevation-z4" color="primary" >
        <div class="buttons-container">
            <button  mat-mini-fab color="primary" (click)="addRow()" matTooltip="{{'actions.add'|translateTA}}">
                <mat-icon>add</mat-icon>
            </button>
            <button  mat-mini-fab (click)="deleteRow()" matTooltip="{{'actions.delete'|translateTA}}">
                <mat-icon>delete</mat-icon> 
            </button>
            <button  mat-mini-fab (click)="massChange()" matTooltip="{{'actions.masschange'|translateTA}}">
                <mat-icon>done_all</mat-icon> 
            </button>
            <mat-divider vertical="true"></mat-divider>
            <button  mat-mini-fab color="success"  (click)="iaROW()" matTooltip="{{'actions.ia'|translateTA}}">
                <mat-icon>neurology</mat-icon> 
            </button>
        </div>
        <div class="spacer"></div>
        <span class="title">{{'translate.title'|translateTA}}</span>
    </mat-toolbar>

    <mat-form-field>
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="{{'translate.placeholer'|translateTA}}" #input>
    </mat-form-field>
    
    <div class="table-container mat-elevation-z8">
        <div class="table-container-inner"> 
            <ngx-spinner bdColor = "rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()"  size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false" name="translation"></ngx-spinner>
            <table mat-table [dataSource]="dataSource"  matSort>
                
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (change)="$event ? toggleAllRows() : null"
                                        [checked]="selection.hasValue() && isAllSelected()"
                                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                                        [aria-label]="checkboxLabel()">
                        </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="$event ? selection.toggle(row) : null"
                                        [checked]="selection.isSelected(row)"
                                        [aria-label]="checkboxLabel(row)">
                        </mat-checkbox>
                        </td>
                    </ng-container>

                    <!-- Position Column -->
                    <ng-container matColumnDef="INTERNALID">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> InternalId. </th>
                    <td mat-cell *matCellDef="let element"> {{element.INTERNALID}} </td>
                    </ng-container>
                
                    <!-- Name Column -->
                    <ng-container matColumnDef="ID">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Tag. ID </th>
                    <td mat-cell *matCellDef="let element"> {{element.ID}} </td>
                    </ng-container>
                
                    <ng-container [matColumnDef]="item.col" *ngFor="let item of languages">
                    <th mat-header-cell *matHeaderCellDef class="col-center" mat-sort-header> {{item.name}} </th>
                    <td mat-cell *matCellDef="let element"> 
                        <mat-form-field appearance="outline" ngClass="no-padding-form-field fill-container" >
                            <textarea  matInput type="text"  #value required  [(ngModel)]="element[item.col]" [disabled]="!element.editMode"  (click)="$event.stopPropagation()"
                            ></textarea>
                        </mat-form-field>
                    </td>
                    </ng-container>


                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef class="col-center">
                            {{'actions'|translateTA}}
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <div class="button-flex-container">
                                <div class="button-container">
                                    <button mat-fab color="primary" (click)="editRow($event,row,row.editMode?'save':'edit')" matTooltip="{{row.editMode?'actions.save':'actions.edit'|translateTA}}">
                                        <mat-icon>{{row.editMode?'check':'edit'}}</mat-icon>
                                    </button>
                                </div>
                                <div class="button-container">
                                    <button mat-fab [disabled]="!row.editMode" (click)="cancelEditRow($event,row)" >
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </ng-container>
                
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"></tr>
                
                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow >
                        <td class="mat-cell" [attr.colspan]="displayedColumns.length" class="no-data-row">{{"simpledatagrid.norows"|translateTA}} {{ input.value}} </td>
                    </tr>
                </table>
            </div> 
            <mat-divider></mat-divider>
            <mat-paginator [pageSizeOptions]="[50, 100, 500]"
                 showFirstLastButtons
                [pageSize]="50"     >
            </mat-paginator>
        </div>
</div>